"use client";

import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

import { clientGet } from "@/service/client-api/client-api";
import { LevelChart } from "@/components/exams/spaced-repetition-progress/level-chart";

export const LearningLevelStatCard = () => {
  const [summary, setSummary] = useState<
    ExamSrProgressSummaryVM | null | undefined
  >(undefined);

  useEffect(() => {
    let active = true;
    clientGet("exam.sr_progress.summary", { queryString: "" })
      .then(
        (data: ExamSrProgressSummaryVM | null) =>
          active && setSummary(data ?? null),
      )
      .catch(() => active && setSummary(null));
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="flex flex-col rounded-2xl border border-zinc-200 bg-white p-4 text-zinc-900 sm:p-6">
      <span className="text-lg font-bold">Poziom nauczenia</span>

      <div className="mt-4 flex flex-1 items-center justify-start sm:justify-center">
        {summary === undefined ? (
          <Loader2 className="size-7 animate-spin text-slate-400" />
        ) : summary === null || summary.total === 0 ? (
          <p className="max-w-[280px] text-left text-sm text-slate-500 sm:text-center">
            Gdy zaczniesz odpowiadać na pytania w module powtórek, pojawi się tu
            Twój poziom nauczenia.
          </p>
        ) : (
          <LevelChart
            levels={summary.levels}
            total={summary.total}
            activeLevels={[]}
            onLevelClick={() => {}}
          />
        )}
      </div>
    </div>
  );
};
